/* eslint-disable max-len */
import type { ChakraComponent } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/react'
import React from 'react'

export const SuccessIcon: ChakraComponent<'svg', any> = (props) => (
  <chakra.svg
    width={'24px'}
    height={'24px'}
    viewBox={'0 0 24 24'}
    fill={'none'}
    {...props}
  >
    <path
      fillRule={'evenodd'}
      clipRule={'evenodd'}
      d={'M11.9999 21.6C17.3018 21.6 21.5999 17.302 21.5999 12C21.5999 6.69809 17.3018 2.40002 11.9999 2.40002C6.69797 2.40002 2.3999 6.69809 2.3999 12C2.3999 17.302 6.69797 21.6 11.9999 21.6ZM16.4484 10.4486C16.9171 9.97992 16.9171 9.22012 16.4484 8.7515C15.9798 8.28287 15.22 8.28287 14.7514 8.7515L10.7999 12.703L9.24843 11.1515C8.7798 10.6829 8.02 10.6829 7.55137 11.1515C7.08274 11.6201 7.08274 12.3799 7.55137 12.8486L9.95137 15.2486C10.42 15.7172 11.1798 15.7172 11.6484 15.2486L16.4484 10.4486Z'}
      fill={'#1D9B37'}
    />
  </chakra.svg>
)
